import React from 'react';
import { FLOAT, INT } from '@/util/ColumnType';
import DataTable from '@/util/DataTable';
import DataTableHeading from '@/util/DataTableHeading';

export type HeaderProps = {
  dataTable: DataTable;
  getColumnLabel: any; // TODO: infer type.
};

export const Header: React.FC<HeaderProps> = ({
  dataTable,
  getColumnLabel,
}) => (
  <thead>
    <tr className="widget-headers">
      {dataTable.headings().map((h: DataTableHeading, index: number) => (
        <th
          key={index}
          className={
            [INT, FLOAT].includes(h.columnType().type())
              ? 'text-align-right'
              : ''
          }
        >
          {getColumnLabel(h)}
        </th>
      ))}
    </tr>
  </thead>
);
